import { InjectionToken } from '@angular/core';
import { I18nConfiguration } from './i18n-configuration.type';

export const I18N_CONFIGURATION = new InjectionToken<I18nConfiguration>(
  'I18N_CONFIGURATION',
);
